export default {
  CartaoCreditoSalvo: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cartao-credito-salvo"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CartaoCreditoSalvo.js
// module id = GSWO
// module chunks = 16